import React from 'react';
import { Chip, Box } from '@material-ui/core';
import CmtTimeLine from '../../../@coremat/CmtTimeLine';
import parse from 'html-react-parser';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import Grid from '@material-ui/core/Grid';
import GridContainer from '../../../@jumbo/components/GridContainer';
import CmtTimeLineItem from '../../../@coremat/CmtTimeLine/CmtTimeLineItem';
import { fade, IconButton, Tooltip } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CmtTimelineContent from '../../../@coremat/CmtTimeLine/CmtTimelineContent';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CmtImage from '../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';

import Button from '@material-ui/core/Button';
import ResDetais from '../timeline/ResDetails';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import NightsStayIcon from '@material-ui/icons/NightsStay';
import HotelIcon from '@material-ui/icons/Hotel';
import HomeIcon from '@material-ui/icons/Home';
import PeopleIcon from '@material-ui/icons/People';
import AssignmentIcon from '@material-ui/icons/Assignment';

import { getMyDate5, getMyDate, getMyDate2 } from '../../../@jumbo/utils/commonHelper';
import { connect } from 'react-redux';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import Swal from 'sweetalert2';
import { injectIntl } from 'react-intl';
const useStyles = theme => ({
  card: {
    overflow: 'unset',
    marginBottom: theme.typography.pxToRem(16),
  },
  cardContent: {
    position: 'relative',
    paddingBottom: 0,
  },
  card2: {
    overflow: 'unset',
    marginBottom: 0,
  },
  cardContent2: {
    position: 'relative',
    paddingBottom: 0,
    textAlign: 'center',
  },
  cardContentInner: {
    position: 'relative',
    paddingBottom: 0,
  },
  cardContentInner2: {
    position: 'relative',
    paddingBottom: 0,
    color: '#ffffff',
  },
  cardContentInner3: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 0,
    color: '#ffffff',
    fontSize: 'x-large',
    height: '100%',
  },
  timelineView: {
    height: '100%',
    position: 'relative',
    '& .Cmt-timeline-item': {
      paddingLeft: 64,
      '&:before': {
        left: 20,
      },
      '&:first-child:before, &:last-child:before': {
        borderLeftStyle: 'solid',
      },
      '& .Cmt-timeline-badge': {
        transition: 'all 0.3s ease',
        transform: 'scale(1)',
      },
      '&:hover': {
        '& .Cmt-timeline-badge': {
          boxShadow: '0 4px 8px rgba(0,0,0,.45)',
          transform: 'scale(1.2)',
        },
      },
    },
    '& .Cmt-timeline-badge': {
      top: 0,
      width: 40,
      height: 40,
    },
  },
  titleRoot: {
    fontWeight: theme.typography.fontWeightRegular,
    letterSpacing: 0.5,
    marginBottom: 4,
    cursor: 'pointer',
  },
  subTitleRoot: {
    fontSize: 12,
    letterSpacing: 0.4,
    color: theme.palette.text.secondary,
  },
  dateRoot: {
    fontSize: 12,
    letterSpacing: 0.4,
    color: theme.palette.text.disabled,
    textAlign: 'right',
  },
});

class ActivitiesTimeLine extends React.Component {
  constructor(props) {
    super(props);
    props = this.props;
    console.log(props.data);
    const mylen = 50;
    const myarray = new Array(mylen).fill(false);
    const myarray2 = new Array(mylen).fill({});
    this.state = {
      visible: myarray,
      resDetails: myarray2,
      selReservationId: '',
      selReservatonTitle: '',
      roomStatus: [],
      roomStatusColor: [],
      selReservationStatus: '',
      resDetailsVisible: false,
    };
    console.log(myarray);
    this.handleClick = this.handleClick.bind(this);
    this.handlePromjena = this.handlePromjena.bind(this);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data !== this.props.data) {
      console.log('t1');
      this.setState({ data: this.props.data });
      const { intl } = this.props;

      const mylen = 50;
      const myarray = new Array(mylen).fill(false);
      const myarray2 = new Array(mylen).fill({});

      var rs = this.state.roomStatus;
      var rc = this.state.roomStatusColor;

      if (
        (this.props.auth.authUser.clouduser == 1 && (this.props.auth.authUser.features & 4) != 0) ||
        this.props.auth.authUser.clouduser == 0
      ) {
        console.log('t2');
        /*     this.props.data.map(function(item, index) {

          rs[item.room_number] = '?';
        });*/
        const token = localStorage.getItem('token');
        var rid = 0;

        /*  this.props.data.map(
          function(item, index) {
            if (Array.isArray(this.props.auth.authUser.rooms))
              this.props.auth.authUser.rooms.forEach(function(el) {
                if (el.Name == item.room_number) {
                  rid = el.ID;
                }
              });*/
        console.log(this.props.data);
        var hid = undefined;
        if (this.props.auth.authUser.clouduser == 1) {
          if (this.props.data == undefined) return;
          if (this.props.data[0] == undefined) return;
          if (this.props.data[0].hid == undefined) return;
          hid = this.props.data[0].hid;
        } else {
          if (this.props.data == undefined) return;
          if (this.props.data[0] == undefined) return;
          if (this.props.data[0].hotel_id == undefined) return;
          hid = this.props.data[0].hotel_id;
          //    hid=this.state.
        }

        console.log('t3');
        const senddata = {
          Action: 'hk_get_status',
          token: token,
          Data: {
            HotelId: hid,
          },
        };
        var pmsUrl = `https://secure.webbookingpro.com/api/pass.php`;
        if (this.props.auth.authUser.clouduser == 0) pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;
        axios.post(pmsUrl, senddata).then(res => {
          console.log(res);
          if (res.data != null && res.data.Data != null) {
            res.data.Data.map(
              function(item, index) {
                var room_number = '';
                /*         if (this.props.auth.authUser.clouduser == 1)
                  if (Array.isArray(this.props.auth.authUser.rooms))
                    this.props.auth.authUser.rooms.forEach(function(el) {
                      if (el.ID == item.ID) {
                        room_number = el.Name;
                      }
                    });
                if (this.props.auth.authUser.clouduser == 0) {
                  if (Array.isArray(this.props.auth.authUser.roomtypes))
                    this.props.auth.authUser.roomtypes.forEach(function(el) {
                      if (el.ID == item.ID) {
                        room_number = el.Name;
                      }
                    });
                  if (String(item.ID).substr(0, 2) == 'rn')
                    if (Array.isArray(this.props.auth.authUser.rooms))
                      this.props.auth.authUser.rooms.forEach(function(el) {
                        if (el.ID == item.ID) {
                          room_number = el.Name;
                        }
                      });
                }*/
                room_number = item.ID;
                var sc = item.Status;
                var status = '',
                  statuscolor = '';
                if (sc == 'C') {
                  status = intl.formatMessage({ id: 'roomClean' });
                  statuscolor = '#00CC6A';
                }
                if (sc == 'N') {
                  status = intl.formatMessage({ id: 'roomDirty' });
                  statuscolor = '#EA005E';
                }
                if (sc == 'S') {
                  status = intl.formatMessage({ id: 'roomChecked' });
                  statuscolor = '#8E8CD8';
                }
                if (sc == 'Z' || sc == 'O') {
                  status = intl.formatMessage({ id: 'roomInUse' });
                  statuscolor = '#FFB900';
                }

                console.log(room_number + ' - ' + status);

                this.setState(prevState => {
                  const rs = [...prevState.roomStatus];
                  var i = rs.findIndex(({ rn }) => room_number === rn);
                  if (i == -1) {
                    var xx = {
                      rn: room_number,
                      Status: status,
                      StatusColor: statuscolor,
                    };
                    rs.push(xx);
                  } else {
                    rs[i].Status = status;
                    rs[i].StatusColor = statuscolor;
                  }

                  /*  const rs = [...prevState.roomStatus];
                  const rc = [...prevState.roomStatusColor];
                  rs[room_number] = status;
                  rc[room_number] = statuscolor;*/
                  return { roomStatus: rs /*, roomStatusColor: rc*/ };
                });
              }.bind(this),
            );
          }
        });

        /*   }.bind(this),
        );*/
      }

      this.setState({ resDetails: myarray2, visible: myarray });
    }
  }

  /* handleSubmit(id, idres, title) {
    if (!this.props.showDetails) return;
    this.setState(prevState => {
      const newItems = [...prevState.visible];
      newItems[id] = !newItems[id];
      return { visible: newItems };
    });
    console.log(this.state.visible);
    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'get_reservation_details',
      token: token,
      Version: 1,
      Data: {
        HotelId: '132',
        AllGuest: 1,
        ReservationId: idres,
      },
    };

    axios.post(`https://secure.webbookingpro.com/api/pass.php`, senddata).then(res => {
      this.setState(prevState => {
        const newItems = [...prevState.resDetails];
        newItems[id] = res.data; //.Data;
        return { resDetails: newItems };
      });
    });
  }
*/
  handleClick(event, idRes, title, status) {
    if (this.props.auth.authUser.clouduser == 1 && this.props.auth.authUser.features == 4) return;
    if (this.props.auth.authUser.role == 5) return;

    this.setState({ selReservationId: idRes });
    this.setState({ selReservationTitle: title });
    this.setState({ resDetailsVisible: true });
    this.setState({ selReservationStatus: status });
  }

  handlePromjena(hotelId, room_number) {
    var room_numberx = '';
    const { intl } = this.props;
    if (this.props.auth.authUser.clouduser == 1)
      if (Array.isArray(this.props.auth.authUser.rooms))
        this.props.auth.authUser.rooms.forEach(function(el) {
          if (el.ID == room_number) {
            room_numberx = el.Name;
          }
        });
    if (this.props.auth.authUser.clouduser == 0) {
      if (Array.isArray(this.props.auth.authUser.roomtypes))
        this.props.auth.authUser.roomtypes.forEach(function(el) {
          if (el.ID == room_number) {
            room_numberx = el.Name;
          }
        });
      if (String(room_number).substr(0, 2) == 'rn')
        if (Array.isArray(this.props.auth.authUser.rooms))
          this.props.auth.authUser.rooms.forEach(function(el) {
            if ('rn' + el.ID == room_number) {
              room_numberx = el.Name;
            }
          });
    }
    /*const rs=[...this.state.roomStatus];
    var i = rs.findIndex(({ rn }) => room_number === rn);
    if (i == -1) return;
    var room_numberx=rs[i].Name;*/
    var r =
      intl.formatMessage({ id: 'setRoomStatus' }) +
      ' ' +
      room_numberx +
      ' ' +
      intl.formatMessage({ id: 'as' }) +
      ' ' +
      intl.formatMessage({ id: 'roomClean' }) +
      '?';

    Swal.fire({
      title: intl.formatMessage({ id: 'bookings.confirmation' }),
      text: r,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({ id: 'yes' }),
      cancelButtonText: intl.formatMessage({ id: 'no' }),
    }).then(result => {
      if (result.isConfirmed) {
        const token = localStorage.getItem('token');
        var rid = 0;
        /*if (this.props.auth.authUser.clouduser == 1) {
          if (Array.isArray(this.props.auth.authUser.rooms))
            this.props.auth.authUser.rooms.forEach(function(el) {
              if (el.Name == room_number) {
                rid = el.ID;
              }
            });
        } else {
          /*        if (Array.isArray(this.props.auth.authUser.roomtypes))
            this.props.auth.authUser.roomtypes.forEach(function(el) {
              if (el.ID == item.ID) {
                room_number = el.Name;
              }
            });
          if (String(item.ID).substr(0,2)=='rn')
            if (Array.isArray(this.props.auth.authUser.rooms))
              this.props.auth.authUser.rooms.forEach(function(el) {
                if (el.ID == item.ID) {
                  room_number = el.Name;
                }
              });
     rid = room_number;
        }*/
        rid = room_number;
        var pmsUrl = `https://secure.webbookingpro.com/api/pass.php`;
        if (this.props.auth.authUser.clouduser == 0) pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;
        const senddata = {
          Action: 'hk_set_status',
          token: token,
          Data: {
            RoomId: rid,
            NewStatus: 'C',
            HotelId: hotelId,
            User: this.props.auth.authUser.name,
          },
        };
        axios.post(pmsUrl, senddata).then(res => {
          var status = intl.formatMessage({ id: 'roomClean' });
          var statuscolor = '#00CC6A';
          this.setState(prevState => {
            const rs = [...prevState.roomStatus];
            var i = rs.findIndex(({ rn }) => room_number === rn);
            if (i == -1) {
              var xx = {
                rn: room_number,
                Status: status,
                StatusColor: statuscolor,
              };
              rs.push(xx);
            } else {
              rs[i].Status = status;
              rs[i].StatusColor = statuscolor;
            }

            /*  const rs = [...prevState.roomStatus];
            const rc = [...prevState.roomStatusColor];
            rs[room_number] = status;
            rc[room_number] = statuscolor;*/
            return { roomStatus: rs /*, roomStatusColor: rc*/ };
          });
          /*        if (this.props.auth.authUser.clouduser == 1)
            if (Array.isArray(this.props.auth.authUser.rooms))
              this.props.auth.authUser.rooms.forEach(function(el) {
                if (el.ID == item.ID) {
                  room_number = el.Name;
                }
              });
          if (this.props.auth.authUser.clouduser == 0) {
            if (Array.isArray(this.props.auth.authUser.roomtypes))
              this.props.auth.authUser.roomtypes.forEach(function(el) {
                if (el.ID == item.ID) {
                  room_number = el.Name;
                }
              });
            if (String(item.ID).substr(0, 2) == 'rn')
              if (Array.isArray(this.props.auth.authUser.rooms))
                this.props.auth.authUser.rooms.forEach(function(el) {
                  if (el.ID == item.ID) {
                    room_number = el.Name;
                  }
                });
          }*/

          /*  this.setState(prevState => {
            const rs = [...prevState.roomStatus];
          //  const rc = [...prevState.roomStatusColor];
            rs[room_number] = status;
            rc[room_number] = statuscolor;
            return { roomStatus: rs, roomStatusColor: rc };
          });*/
        });
      }
    });
  }

  render() {
    const { classes } = this.props;
    console.log('roomstatus');
    console.log(this.state.roomStatus);

    return (
      <>
        {' '}
        {this.props.data.map((item, index) => (
          <CmtCard className={classes.card}>
            <CmtCardContent className={classes.cardContent}>
              <Box className={classes.cardContentInner}>
                {this.props.auth.authUser.clouduser == 0 && (
                  <GridContainer spacing={6}>
                    <Grid item xs={3} sm={3} xl={3}>
                      <CmtCard className={classes.card2} backgroundColor="#135385">
                        <CmtCardContent className={classes.cardContent2}>
                          <Box
                            className={classes.cardContentInner2}
                            onClick={event =>
                              this.handleClick(index, item.idres, item.hotelname + ': ' + item.bId + ': ' + item.title, '')
                            }>
                            {parse(item.checkin)}
                            <hr />
                            {parse(item.checkout)}
                          </Box>
                        </CmtCardContent>
                      </CmtCard>
                    </Grid>

                    <Grid item xs={9} sm={9} xl={9}>
                      <GridContainer spacing={2}>
                        <Grid item xs={6} sm={6} xl={6}>
                          <Typography style={{ fontWeight: 600 }}>{item.title}</Typography>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          xl={6}
                          container
                          direction="row"
                          justify="flex-end"
                          onClick={event =>
                            this.handleClick(index, item.idres, item.hotelname + ': ' + item.bId + ': ' + item.title, '')
                          }>
                          <MoreVertIcon />
                        </Grid>
                        <Grid item xs={6} sm={6} xl={6} container direction="row" alignItems="center">
                          <AssignmentIcon />
                          {item.bId}
                        </Grid>
                        <Grid item xs={6} sm={6} xl={6}></Grid>
                        <Grid xs={4} sm={4} xl={4} container direction="row" alignItems="center">
                          <NightsStayIcon />
                          {'  '}
                          {item.nights}
                        </Grid>
                        <Grid item xs={8} sm={8} xl={8} container direction="row" alignItems="center">
                          <PeopleIcon />
                          {'  '}
                          {item.adults}
                          {' + '}
                          {item.children}
                        </Grid>
                        <Grid item xs={4} sm={4} xl={4} container direction="row" alignItems="center">
                          <HotelIcon />
                          {'  '}
                          {item.roomname}
                        </Grid>
                        <Grid item xs={8} sm={8} xl={8} container direction="row" alignItems="center">
                          <HomeIcon />
                          {'  '}
                          {item.hotelname}
                        </Grid>
                      </GridContainer>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6} container direction="row" alignItems="center">
                      {console.log(item)}
                      {this.state.roomStatus.filter(({ rn }) => rn == item.roomId) != null &&
                        this.state.roomStatus.filter(({ rn }) => rn == item.roomId).length > 0 &&
                        this.state.roomStatus.filter(({ rn }) => rn == item.roomId)[0].Status != '' && (
                          <Chip
                            onClick={() => this.handlePromjena(item.hotel_id, item.roomId)}
                            label={this.state.roomStatus.filter(({ rn }) => rn == item.roomId)[0].Status}
                            style={{
                              backgroundColor: this.state.roomStatus.filter(({ rn }) => rn == item.roomId)[0].StatusColor,
                              borderRadius: 2,
                              marginRight: 5,
                            }}
                          />
                        )}
                      {item.status != '' && (
                        <Chip label={item.status} style={{ borderRadius: 2, backgroundColor: item.color }} />
                      )}
                      {item.source != null && item.source != '' && item.sourceicon != '' && (
                        <img
                          src={'https://app.webbookingpro.com/images/channels/' + item.sourceicon}
                          style={{ height: 32 }}
                        />
                      )}
                      {item.source != null && item.source != '' && item.sourceicon == '' && (
                        <Chip
                          label={item.source}
                          style={{ borderRadius: 2, backgroundColor: item.sourcecolor, color: item.sourceFontColor }}
                        />
                      )}
                      {item.checkedInStatus != null && item.checkedInStatus == '1' && (
                        <Chip
                          label=<IntlMessages id="status.checkedin" />
                          style={{ borderRadius: 2, backgroundColor: '#40FF40' }}
                        />
                      )}
                      {item.checkedInStatus != null && item.checkedInStatus == '2' && (
                        <Chip
                          label=<IntlMessages id="status.checkedout" />
                          style={{ borderRadius: 2, backgroundColor: '#FF4D4D' }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6} container direction="row" alignItems="flex-end" justify="flex-end">
                      <Typography style={{ fontSize: 'small', fontWeight: 300 }}>
                        {item.price}

                        {item.balance != null && (
                          <>
                            {' , '}
                            <IntlMessages id="balance" />
                            {': '}
                            {item.balance}
                          </>
                        )}
                        {item.allFolios != null && (
                          <>
                            {' , '}
                            {item.allFolios == 0 && <IntlMessages id="noFoliosCreated" />}
                            {item.allFolios > 0 && item.openFolios > 0 && (
                              <>
                                {item.openFolios} <IntlMessages id="foliosOpened" />
                              </>
                            )}
                            {item.allFolios > 0 && item.openFolios == 0 && <IntlMessages id="allFoliosClosed" />}
                          </>
                        )}
                      </Typography>
                    </Grid>
                  </GridContainer>
                )}
                {this.props.auth.authUser.clouduser == 1 && (
                  <GridContainer spacing={6}>
                    <Grid item xs={3} sm={3} xl={3}>
                      <CmtCard className={classes.card2} backgroundColor="#135385">
                        <Box className={classes.cardContentInner3}>
                          {' '}
                          <br />
                          {item.room_number}
                          <br />
                          <br />
                        </Box>
                      </CmtCard>
                    </Grid>

                    <Grid item xs={9} sm={9} xl={9}>
                      <GridContainer spacing={1}>
                        <Grid item xs={10} sm={6} xl={6} direction="row" justifyContent="flex-start">
                          <Typography style={{ fontWeight: 600 }}>{item.title}</Typography>
                        </Grid>
                        <Grid item xs={2} sm={6} xl={6} container direction="row" justify="flex-end">
                          <MoreVertIcon />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          xl={6}
                          container
                          direction="row"
                          alignItems="center"
                          justifyContent="flex-start">
                          <AssignmentIcon />
                          <Typography ml={2}>{item.bId}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} xl={6}></Grid>
                        <Grid item container xs={12} sm={12} xl={12} direction="row" alignItems="center">
                          <NightsStayIcon />
                          <Typography ml={2}>
                            {item.checkin}
                            {' - '}
                            {item.checkout}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={6} xl={6} container direction="row" alignItems="center">
                          <HotelIcon />
                          <Typography ml={2}>{item.roomname}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} xl={6} container direction="row" alignItems="center">
                          <PeopleIcon />
                          <Typography sx={{ marginLeft: 2, paddingLeft: 2 }}>
                            {item.adults} {' / '} {item.children}
                          </Typography>
                        </Grid>
                      </GridContainer>
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6} container direction="row" alignItems="center">
                      {item.status != '' && (
                        <Chip label={item.status} style={{ backgroundColor: item.color, borderRadius: 2, marginRight: 5 }} />
                      )}
                      {item.source != null && item.source != '' && (
                        <Chip
                          label={item.source}
                          style={{ backgroundColor: item.sourcecolor, borderRadius: 2, marginRight: 5 }}
                        />
                      )}
                      {this.state.roomStatus.filter(({ rn }) => rn == item.roomId) != null &&
                        this.state.roomStatus.filter(({ rn }) => rn == item.roomId).length > 0 &&
                        this.state.roomStatus.filter(({ rn }) => rn == item.roomId)[0].Status != '' && (
                          <Chip
                            onClick={() => this.handlePromjena(item.hid, item.roomId)}
                            label={this.state.roomStatus.filter(({ rn }) => rn == item.roomId)[0].Status}
                            style={{
                              backgroundColor: this.state.roomStatus.filter(({ rn }) => rn == item.roomId)[0].StatusColor,
                              borderRadius: 2,
                              marginRight: 5,
                            }}
                          />
                        )}
                    </Grid>
                    <Grid item xs={6} sm={6} xl={6} container direction="row" alignItems="center" justify="flex-end">
                      <Typography style={{ fontSize: 'small', fontWeight: 300 }}>{item.price}</Typography>
                    </Grid>
                  </GridContainer>
                )}
              </Box>
            </CmtCardContent>
          </CmtCard>
        ))}
        <ResDetais
          resId={this.state.selReservationId}
          resTitle={this.state.selReservationTitle}
          resStatus={this.state.selReservationStatus}
          open={this.state.resDetailsVisible}
          setState={p => {
            this.setState(p);
          }}
        />
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(ActivitiesTimeLine)));
